import { Card } from "antd";

export default function DashboardPanel({
  title,
  icon,
  extra,
  className = "",
  children,
}) {
  return (
    <Card
      size="small"
      className={`dashboard-panel ${className}`}
      style={{ height: "100%", display: "flex", flexDirection: "column" }}
      bodyStyle={{ flex: 1, display: "flex", flexDirection: "column" }}
      title={
        <span className="panel-title">
          {icon && <span className="panel-icon">{icon}</span>}
          {title}
        </span>
      }
      extra={extra}
    >
      {children}
    </Card>
  );
}
